<template>
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12" text="true" headerTitle="true" :title="t('AddEditPage')">
                <div class="row g-xl-5 g-3">
                    
                <addmenupage />
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { addMenuPageLanguage } from '@/core/locales/page-list-language';
const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const addmenupage = defineAsyncComponent (() => import ("@/components/theme/ecommerce/addpagelist/addmenupage.vue"))
const { t } = useI18n({
    messages: addMenuPageLanguage
});
</script>